<div class="h-full">
  <div class="h-full grid grid-cols-1 md:grid-cols-2">
    <div class="flex flex-col justify-center px-4 lg:px-20 xl:px-24 py-12">
      <div class="flex flex-col w-full max-w-99 mx-auto">
        <div>
          <img
            class="max-w-50"
            src="logo_dark.svg"
            alt="logo"
            width="200"
            height="30"
          />
          <h2 class="text-2xl mt-8 font-semibold">
            <ng-content select="[slot=title]"></ng-content>
          </h2>
          <p class="text-gray-500 mt-2">
            <ng-content select="[slot=message]"></ng-content>
          </p>
        </div>

        <ng-content select="[slot=content]"></ng-content>
      </div>
    </div>
    <div class="h-full overflow-hidden hidden md:block">
      <div class="h-full p-4">
        <div class="h-full rounded-2xl relative overflow-hidden pointer-events-none bg-gray-50">
          <img
            class="object-cover transition-opacity duration-700 ease-in-out"
            [class.opacity-0]="!imageLoaded()"
            [class.opacity-100]="imageLoaded()"
            [ngSrc]="randomImageSrc()"
            alt=""
            fill
            priority
            (load)="imageLoaded.set(true)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
